import React from 'react';
import { SocialListInput } from './SocialListInput';

type SocialItem = {
  type: 'instagram' | 'linkedin' | 'youtube' | 'twitter' | 'tiktok';
  link: string;
};

interface SocialFieldProps {
  label: string;
  required?: boolean;
  value: SocialItem[];
  onChange: (_value: SocialItem[]) => void;
  error?: string;
}

export const SocialField: React.FC<SocialFieldProps> = ({
  label,
  required,
  value,
  onChange,
  error
}) => {
  return (
    <div className="space-y-2">
      <label className="block text-sm font-medium text-gray-700">
        {label}
        {required && <span className="text-red-500 ml-1">*</span>}
      </label>
      <SocialListInput value={value} onChange={onChange} />
      {error && (
        <p className="text-red-500 text-sm">{error}</p>
      )}
    </div>
  );
};

